<div *ngIf="plans$ | async as plans">
    <bx-web-take-off-scale-plans-v2
        [plans]="plans"
        [selectedPlan]="plans[0]"
        (scaleComplete)="navigateToMeasurements()"></bx-web-take-off-scale-plans-v2>
</div>
